var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import Button from "../../../components/connect-ui/Button";
import { FullWidthForm } from "../../../components/Styles/Styles";
import TextField from "../../../components/connect-ui/TextField";
import { useLocation } from "react-router-dom";
import { usePostQuestionMutation } from "../../../services/connect";
function questionReducer(state, nextState) {
    return __assign(__assign({}, state), nextState);
}
var initialState = {
    answer: "",
    failed: false,
    inProgress: false,
    error: false,
};
export default function SecurityQuestion(_a) {
    var _this = this;
    var connectionId = _a.connectionId, challengeData = _a.challengeData;
    var _b = React.useReducer(questionReducer, initialState), _c = _b[0], failed = _c.failed, inProgress = _c.inProgress, answer = _c.answer, error = _c.error, setState = _b[1];
    var location = useLocation();
    var postQuestion = usePostQuestionMutation({
        fixedCacheKey: location.pathname,
    })[0];
    function handleFail() {
        setState({ failed: true, inProgress: false });
    }
    var handleTokenChange = function (event) {
        setState({ answer: event.target.value });
    };
    var handleSubmit = function (event) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            event.preventDefault();
            setState({ failed: false, inProgress: true });
            if (challengeData === null || challengeData === void 0 ? void 0 : challengeData.challengeQuestionId) {
                postQuestion({
                    id: connectionId,
                    questionId: challengeData.challengeQuestionId,
                    answer: answer,
                })
                    .unwrap()
                    .then(function (_a) {
                    var result = _a.result;
                    if (!result) {
                        handleFail();
                    }
                })
                    .catch(function () {
                    handleFail();
                });
            }
            else {
                setState({ error: true });
            }
            return [2 /*return*/];
        });
    }); };
    if (error) {
        throw new Error("Error while rendering security question: missing question ID");
    }
    return (React.createElement(FullWidthForm, null,
        React.createElement("p", { className: "mb-6 text-xl" }, "Security Question"),
        failed ? (React.createElement("p", { className: "text-red-700 mb-6 text-sm" }, "Unrecognized answer, please try again.")) : null,
        React.createElement("div", { className: "w-full" },
            React.createElement("p", { className: "mb-6 text-sm" }, challengeData === null || challengeData === void 0 ? void 0 : challengeData.challengeQuestion)),
        React.createElement(TextField, { id: "security-question", name: "security-question", type: "text", className: "security-question mb-4", onChange: handleTokenChange, label: "Answer", required: true }),
        React.createElement(Button, { type: "submit", disabled: inProgress, onClick: handleSubmit }, inProgress ? "Validating..." : "Submit")));
}
